import { getFormattedAmountUI } from '@axo/shared/util/formatters';

type getESkatDetailsDisplayValueArgs = {
  field: string;
  value: unknown;
  t: (text: string) => string;
};
export const getESkatDetailsDisplayValues = ({
  field,
  value,
  t,
}: getESkatDetailsDisplayValueArgs) => {
  let displayValue;

  switch (typeof value) {
    case 'number':
      if (field.includes('Income') || field.includes('Cost')) {
        displayValue = `${getFormattedAmountUI(Number(value))} ${t(
          'suffix.currency'
        )}`;
      } else {
        displayValue = value;
      }
      break;

    case 'string':
      switch (field) {
        // Mutator Denmark is not parsing NetIncomeMonthly to number
        case 'NetIncomeMonthly':
          displayValue = `${getFormattedAmountUI(Number(value))} ${t(
            'suffix.currency'
          )}`;
          break;

        case 'CompanyOrganizationNumber':
        case 'YearsAsBankCustomer':
        case 'AccountNumber':
        case 'RegistrationNumber':
        case 'FirstName':
        case 'LastName':
        case 'SocialSecurityNumber':
          displayValue = value;
          break;

        case 'EmploymentStatusSince':
        case 'LivedAtAddressSince':
          displayValue = new Date(value).getFullYear();
          break;

        default: {
          displayValue = t(`${field}.${value}`);
          break;
        }
      }
  }

  switch (value) {
    case 'Yes':
    case 'No':
      displayValue = t(`${value.toLowerCase()}`);
      break;

    default:
      break;
  }

  return {
    title: t(`${field}.title`),
    displayValue,
  };
};
